import { FC } from 'react';

const BookPage: FC = () => {
    return (
        <>
            <hr />
            <h1>BookPage 1</h1>
            <hr />
        </>
    );
};

export default BookPage;
